module.exports = __webpack_public_path__ + "static/media/downarrow.5716eee6.svg";